/**
 * Scroll to section based on link's href
 *
 * @param {}
 * @return {void}
 */

$('.js-scroll-to-section').on('click', function(e) {
  e.preventDefault();

  const href = $(this).attr('href');
  const $section = $(href);

  if ($section.length == 0) {
    return;
  }

  const containerHeight = $section.offset().top;
  const headerHeight = $('.js-header').outerHeight();
  const scrollThisMuch = containerHeight;

  if ($(this).hasClass('js-glossary-scroll-link')) {
    if ( ! $(this).parent().hasClass('is-active')) {
      return;
    }
  }

  $('html, body').animate({
    scrollTop: scrollThisMuch
  }, 600);
});


